import axios from "@/utils/axios";
import { staticObj } from "./static";
import _ from "lodash";
export const selectData = _.cloneDeep(staticObj);
// console.log(selectData);
// 字典项缓存函数
const selectKey = {
  teamLevel: async () => {
    const res = await axios.get(
      `/suncn-base-system/system/param/business/getBusinessListByGroupName/团组级别`
    );
    return res.data.data.map((item) => ({
      value: item.id,
      label: item.paramName,
    }));
  },
  guestType: async () => {
    const res = await axios.get(
      `/suncn-base-system/system/param/business/getBusinessListByGroupName/内外宾`
    );
    return res.data.data.map((item) => ({
      value: item.id,
      label: item.paramName,
    }));
  },
  teamType: async () => {
    const res = await axios.get(
      `/suncn-base-system/system/param/business/getBusinessListByGroupName/团组类别`
    );
    return res.data.map((item) => ({
      value: item.id,
      label: item.paramName,
    }));
  },
};
// 获取公共数据字典
const publicDic = async function (params) {
  const res = await axios.post("/system/param/public/getListByGroupName", {
    ...params,
  });
  const list = res?.data?.data;
  return list.map((item) => {
    return {
      value: item.paramCode,
      label: item.paramName,
      easyLabel: item.paramSimpleName,
    };
  });
};
// forceRefresh 强制刷新标识
export async function getSelect(item, forceRefresh = false) {
  const isString = typeof item === "string";
  const key = isString ? item : item?.key; // 判断当前传入类型 获取字段key
  // 通过key获取option方法内部
  if (!forceRefresh && selectData[key]) {
    // 首先判断是否缓存过该数据，如果缓存了 则直接从缓存中读取
    return selectData[key]; // 返回缓存的值
  } else {
    if (isString) {
      selectData[key] = await selectKey[key](); // 更新缓存
    } else {
      selectData[key] = publicDic(item);
    }
    return selectData[key]; // 返回缓存的值
  }
}
// 重置字典
export const resetDict = function (name) {
  if (!name) {
    // 如果name为空，则重置所有字典
    for (const key in selectData) {
      if (Object.hasOwnProperty.call(selectData, key)) {
        delete selectData[key];
      }
    }
    Object.assign(selectData, staticObj);
  } else {
    selectData[name] = null;
  }
};
